export const endpoints = {
  beerWebsite: 'rating/websiteBeers'
};
